import { useSessionStorage } from "react-use";
import { EventBanner as EventBannerType } from "../../../types/general-types";
import EventBanner from "../../../components/event-banner";

type EventBannersProps = {
	eventBanners: EventBannerType[];
};

export default function EventBanners({ eventBanners }: EventBannersProps) {
	const [dismissedBanners, setDismissedBanners] = useSessionStorage<number[]>("verity-banners-dismissed", []);
	const visibleBanners = eventBanners.filter((banner) => !dismissedBanners.includes(banner.id));

	const handleDismiss = () => {
		if (visibleBanners.length === 0) return;
		const currentBannerIds = visibleBanners.map((banner) => banner.id);
		setDismissedBanners(Array.from(new Set([...dismissedBanners, ...currentBannerIds])));
	};

	if (visibleBanners.length === 0) return null;

	return <EventBanner banners={visibleBanners} onClose={handleDismiss} />;
}
